import styled from 'styled-components'

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  z-index: 100;
  width: 900px;
  justify-content: space-between;
`
